import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMapPin, FiClock, FiLock } = FiIcons;

const Footer = () => {
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/0fbf60f8fa242397e9ef833782db8ed93045df54e3b36d72437cb9900e44cd21f118b78650ffb5dd82aaaddf0850c39a/images/aW1hZ2UvanBlZw==/f2db29be14ca2eb40f068da8d183a853.jpeg";

  const cityLinks = [
    { name: 'Ontario', path: '/ontario-ca' },
    { name: 'Rancho Cucamonga', path: '/rancho-cucamonga-ca' },
    { name: 'Upland', path: '/upland-ca' },
    { name: 'Fontana', path: '/fontana-ca' },
    { name: 'Chino', path: '/chino-ca' },
    { name: 'Pomona', path: '/pomona-ca' },
    { name: 'San Bernardino', path: '/san-bernardino-ca' },
    { name: 'Riverside', path: '/riverside-ca' }
  ];

  return (
    <footer className="bg-gray-900 text-white border-t border-gray-800" role="contentinfo">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img src={logoUrl} alt="Ramirez Mobile Clean Truck CARB Compliance Logo" className="h-16 w-auto object-contain" loading="lazy" />
            </div>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed">
              Professional mobile CARB compliance and emissions testing services throughout Southern California. We keep your fleet running clean and compliant.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 group">
                <div className="p-2 bg-blue-900/30 rounded-full group-hover:bg-blue-600 transition-colors">
                  <SafeIcon icon={FiPhone} className="text-blue-400 group-hover:text-white" aria-hidden="true" />
                </div>
                <a href="tel:9092842738" className="hover:text-blue-400 transition-colors font-medium" aria-label="Call Us at (909) 284-2738">
                  (909) 284-2738
                </a>
              </div>
              <div className="flex items-center space-x-3 group">
                <div className="p-2 bg-blue-900/30 rounded-full group-hover:bg-blue-600 transition-colors">
                  <SafeIcon icon={FiMapPin} className="text-blue-400 group-hover:text-white" aria-hidden="true" />
                </div>
                <a href="https://share.google/3y2ABFaMxbdz6hzaZ" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors text-sm" aria-label="View our service area on Google Maps">
                  Ontario, CA & Surrounding Areas
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white border-b-2 border-blue-600 inline-block pb-1">Our Services</h4>
            <ul className="space-y-3 text-gray-400">
              <li><Link to="/services" className="hover:text-blue-400 transition-colors flex items-center gap-2" title="CARB Compliance Services"><span className="w-1 h-1 bg-blue-500 rounded-full"></span>CARB Compliance</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors flex items-center gap-2" title="Emissions Testing Services"><span className="w-1 h-1 bg-blue-500 rounded-full"></span>Emissions Testing</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors flex items-center gap-2" title="Mobile Service"><span className="w-1 h-1 bg-blue-500 rounded-full"></span>Mobile Service</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors flex items-center gap-2" title="Fleet Maintenance"><span className="w-1 h-1 bg-blue-500 rounded-full"></span>Fleet Maintenance</Link></li>
              <li><Link to="/blog" className="hover:text-blue-400 transition-colors flex items-center gap-2" title="CARB Compliance Blog"><span className="w-1 h-1 bg-blue-500 rounded-full"></span>Compliance Blog</Link></li>
              <li><Link to="/faq" className="hover:text-blue-400 transition-colors flex items-center gap-2" title="Questions and Answers"><span className="w-1 h-1 bg-blue-500 rounded-full"></span>Questions & Answers</Link></li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white border-b-2 border-blue-600 inline-block pb-1">Service Areas</h4>
            <ul className="grid grid-cols-1 gap-2 text-gray-400">
              {cityLinks.map((city) => (
                <li key={city.path}>
                  <Link to={city.path} className="hover:text-blue-400 transition-colors text-sm flex items-center gap-2" title={`CARB Compliance in ${city.name}`}>
                    <SafeIcon icon={FiMapPin} className="text-xs opacity-50" aria-hidden="true" />
                    {city.name}, CA
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white border-b-2 border-blue-600 inline-block pb-1">Business Hours</h4>
            <div className="space-y-4">
              <div className="bg-gray-800 p-4 rounded-lg border border-gray-700">
                <div className="flex items-center space-x-2 text-blue-400 mb-1">
                  <SafeIcon icon={FiClock} aria-hidden="true" />
                  <span className="font-semibold text-sm">Monday - Saturday</span>
                </div>
                <p className="text-2xl font-bold text-white">7:00 AM - 6:00 PM</p>
                <div className="mt-2 pt-2 border-t border-gray-700">
                  <p className="text-sm text-yellow-500 font-semibold flex items-center gap-2">
                    <span className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></span>
                    Emergency Service Available
                  </p>
                </div>
              </div>
              <Link 
                to="/contact" 
                className="w-full bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors flex justify-center items-center font-bold shadow-lg shadow-blue-900/20"
                aria-label="Request a free quote online"
              >
                Request a Quote
              </Link>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Ramirez Mobile Clean Truck. All rights reserved.</p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <Link to="/sitemap" className="hover:text-white transition-colors" title="Website Sitemap">Sitemap</Link>
            <Link to="/cpanel" className="hover:text-white transition-colors flex items-center gap-2 group" aria-label="Admin Login Portal">
              <SafeIcon icon={FiLock} className="text-xs group-hover:text-blue-400" aria-hidden="true" />
              <span>Admin Login</span>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;